import Repository from "./Repository"
import axios from "axios"

export default {
  /**
   * Get all reviews
   */
  getReviews(circle_id, page = 1, items = 10, filterType, doctorType, searchKey, sortKey) {
    const f = filterType ? `&reviewee_role=${filterType}` : ""
    const d = doctorType ? `&type=${doctorType}` : ""
    const s = searchKey ? `&search=${searchKey}` : ""
    const sort = sortKey ? `&sort=${sortKey}` : ""
    return Repository.get(`/allreviews/?page_num=${page}&items=${items}&circle_id=${circle_id}&recommended=False` + f + d + s + sort)
  },

  getCoreReviews(headers, type, page, searchKey, sortKey, page_size = 10) {
    const s = searchKey ? `&full_name=${searchKey}` : ""
    const sort = sortKey !== "newest" ? `&ordering=${sortKey}` : ""
    return axios({
      headers: headers,
      method: "get",
      url: `${process.env.SSO_BASE_URL}/api/v2/review/${type}/review/?page=${page}&page_size=${page_size}` + s + sort,
    })
  },

  getIndividualCoreReviews(headers, type, id, page, sortKey, page_size = 10) {
    const sort = sortKey !== "newest" ? `&ordering=${sortKey}` : ""
    return axios({
      headers: headers,
      method: "get",
      url: `${process.env.SSO_BASE_URL}/api/v2/${type}/${id}/review/?page=${page}&page_size=${page_size}` + sort,
    })
  },

  getIndividualReviews(circle_id, page = 1, items = 10, reviewee_id, type, sort, role, revType) {
    const t = type ? `&type=${type}` : ""
    const s = sort ? `&sort=${sort}` : ""
    const r = role ? `&reviewee_role=${role}` : ""
    return Repository.get(`/allreviews/?page_num=${page}&items=${items}&circle_id=${circle_id}&reviewee_id=${reviewee_id}&recommended=False` + t + s + r)
  },

  // get single review/recommend using the id
  getReviewFromId(id) {
    return Repository.get("/reviews/?id=" + id)
  },

  // get my circle id of user
  getMyCircleID(circle_id, ext_ref_id, role) {
    return Repository.get(
      `/mycircleid/?ext_ref_id=${ext_ref_id}&circle_id=${circle_id}&role=${role}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/repositories/reviewsRepository.js